import { useState } from 'react';
import {
    Button,
    Popover,
    List,
    ListItem,
} from '@material-ui/core';
import { ReportProblemRounded } from '@material-ui/icons';
import { ManagerWarningType, ManagerWarningTypeNames } from '../../Enums';
import './ManagerWarning.scss';

const GenericWarning = (props) => (
    <ListItem {...props}>
        { props.children }
    </ListItem>
);

/**
 * @typedef {{ warnings: BidProfile.IManagerWarning[], t: *, isMini?: boolean }} ManagerWarningProps
 * @param {ManagerWarningProps} props
 */
function ManagerWarning(props) {
    const { warnings = [], t, isMini = false } = props;
    /**
     * @type {[HTMLInputElement | null, Function]}
     */
    const [anchorEl, setAnchorEl] = useState(null);

    /**
     * @param {React.MouseEvent<HTMLButtonElement, MouseEvent>} e
     */
    const handleClick = (e) => {
        setAnchorEl(e.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'import-warnings-popover' : undefined;
    const hasWarnings = !!warnings.length;
    const buttonStyles = isMini ? '' : 'mw-button-container';
    const listStyles = isMini ? 'mw-warnings-list-mini' : '';

    return (
        <div className="mw-container">
            <Button
                onClick={handleClick}
                className={buttonStyles}
                disabled={!hasWarnings}
            >
                <ReportProblemRounded style={{ color: 'orange', paddingRight: '2px' }} />
                { !isMini && (
                    <span className="mw-label-text">
                        {`${warnings.length} ${warnings.length === 1 ? 'warning' : 'warnings'}`}
                    </span>
                )}
            </Button>
            <Popover
                id={id}
                classes={{
                    paper: 'mw-popover-paper',
                }}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
            >
                <List className={listStyles}>
                    {
                        warnings.map((x) => {
                            if (x.type === ManagerWarningType.EmployeeCountGreaterThanLines) {
                                return (
                                    <GenericWarning
                                        key={x.type}
                                        className="mw-warnings-list-item"
                                    >
                                        <span className="mw-label-schedule-pattern-name">
                                            {t(`form.managerWarnings.${ManagerWarningTypeNames[x.type]}`)}
                                        </span>
                                    </GenericWarning>
                                );
                            }
                            if (x.type === ManagerWarningType.EmployeeCountLesserThanLines) {
                                return (
                                    <GenericWarning
                                        key={x.type}
                                        className="mw-warnings-list-item"
                                    >
                                        <span className="mw-label-schedule-pattern-name">
                                            {t(`form.managerWarnings.${ManagerWarningTypeNames[x.type]}`)}
                                        </span>
                                    </GenericWarning>
                                );
                            }

                            return null;
                        })
                    }
                </List>
            </Popover>
        </div>

    );
}

export default ManagerWarning;
